import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {LayersControl, MapContainer, Marker, useMap, useMapEvents} from "react-leaflet";
//import "leaflet/dist/leaflet.css";
import "leaflet-geosearch/dist/geosearch.css";
import {GeoSearchControl, OpenStreetMapProvider} from "leaflet-geosearch";
import axios from "axios";
import ENV from "../ENV.json";
import L from "leaflet";
import Popup from "./Popup";
import {useHistory} from "react-router-dom";
import MapLayerControl from "./MapLayerControl";

const DimensioneMap = (props) => {
    const history = useHistory();

    const [center, setCenter] = useState(props?.startPos ? props?.startPos : {lat: 41.6421, lng: 14.5418});

    const [draggable, setDraggable] = useState(false)
    const [position, setPosition] = useState(center)

    const [zoom, setZoom] = useState(props?.zoom || 9);

    const markerRef = useRef(null)

    const eventHandlers = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current
                if (marker != null) {
                    setPosition(marker.getLatLng())
                    if (props?.onEdit) {
                        props.onEdit(marker.getLatLng());
                    }
                }
            },
        }),
        [],
    )

    useEffect(()=>{
        if(props?.pos && props?.pos?.lat && props?.pos?.lng){
            //console.log("Sto per settare la props?.pos a valori "+props?.pos)
            //console.log(props?.pos)
            setPosition(props?.pos)
        }
    },[props?.pos])


    //Punti di interesse e il loro caricamento
    const [isPoiDownloading, setIsPoiDownloading] = useState(false);
    const [pois, setPois] = useState([]);

    //Punti di interesse salvati
    const [isPoiTempDownloading, setIsPoiTempDownloading] = useState(false);
    const [temp_pois, setTempPois] = useState([]);

    //POPUPS STATE
    const [modalOpen, setModalOpen] = useState(false);
    const [popupData, setPopupData] = useState({});

    //Carica i dati nel momento della visualizzazione della pagina
    useEffect(() => {
        loadPoi();
        loadTempPoi();
    }, []);

    const logout = useCallback(() => history.push('/'), [history]);

    //Callback per ottenere tutti i poi.
    const loadPoi = useCallback(() => {
        setIsPoiDownloading(true);
        axios.get(`${ENV[ENV.ENV_STATE].baseUrl}/get/all/poi`)
            .then(function (response) {
                if (response?.data?.status) {
                    delete response?.data?.meta;
                    console.log(response?.data?.rows);
                    setPois(response?.data?.rows);
                } else {
                    setPopupData(response?.data);
                    setModalOpen(true);
                }
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile caricare i punti di interesse"
                })
                setModalOpen(true);
                if (error.response.status === 403) {
                    logout();
                }
            })
            .then(function (response) {
                setIsPoiDownloading(false)
            });
    }, []);
    //Callback per ottenere tutti i poi temporanei.
    const loadTempPoi = useCallback(() => {
        setIsPoiTempDownloading(true)
        axios.get(`${ENV[ENV.ENV_STATE].baseUrl}/get/all/poi/temp`)
            .then(function (response) {
                if (response?.data?.status) {
                    delete response?.data?.meta;
                    setTempPois(response?.data?.result);
                } else {
                    setPopupData(response?.data)
                    setModalOpen(true);
                }
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile caricare i punti di interesse salvati"
                })
                setModalOpen(true);
                if (error.response.status === 403) {
                    logout();
                }
            })
            .then(function (response) {
                setIsPoiTempDownloading(false)
            });
    }, []);

    //DETERMINATE GPS
    useEffect(() => {
        if (props?.startPos) {
            setPosition(props?.startPos)
        } else {
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    setPosition({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    })
                });
            } else {
                setPosition({
                    lat: 41.5532,
                    lng: 14.6267,
                })
            }
        }
    }, []);

    //Componente per la ricerca
    function LeafletgeoSearch() {
        const map = useMap();
        useEffect(() => {
            const provider = new OpenStreetMapProvider();
            const searchControl = new GeoSearchControl({
                provider,
                showMarker: false,
                /*marker: {
                    icon
                }*/
            });
            map.addControl(searchControl);
            return () => map.removeControl(searchControl);
        }, []);
        return null;
    }

    //Componente per ricevere gli eventi
    function ClickInteraction() {
        const map = useMapEvents({
            click: (e) => {
                setPosition(e.latlng)
                if(props?.onEdit){
                    props?.onEdit(e.latlng)
                }
            },
            zoomend: () => {
                //console.log("Zoom end")
                setZoom(map.getZoom());
            },
        });
        return null;
    }

    function GetTempIcon(_iconSize, name) {
        return L.icon({
            iconUrl: require(`../${name}`),
            iconSize: [_iconSize]
        })
    }

    function MarkerCustom(props) {
        return props?.data?.position === null ? null : (
            <Marker
                icon={GetTempIcon(props?.size, props?.name)}
                draggable={props?.data?.draggable}
                position={{lat: props?.data?.position?.lat, lng: props?.data?.position?.lng}}
                eventHandlers={{
                    click: (e) => {
                        //console.log(`Cliccato ${props?.data?.title}`)
                        //if (props?.onClick) props?.onClick(props?.data?.ID);
                    },
                }}
            >
                <Popup>{props?.data?.title}</Popup>
            </Marker>
        )
    }

    return (
        <div style={{border: '1px solid black', width: '100%', height: '500px'}}>
            <MapContainer
                center={center}
                zoom={zoom}
                scrollWheelZoom={true}
                style={{height: "100%"}}
            >
                <LayersControl position="topright">
                    <MapLayerControl/>
                    <Marker
                        draggable={true}
                        eventHandlers={eventHandlers}
                        position={position}
                        ref={markerRef}>
                    </Marker>
                    {
                        pois && pois.map(elem => (
                            <MarkerCustom
                                size={32}
                                name="GPS_SAVED.png"
                                key={elem?.ID}
                                data={{
                                    ID: elem?.ID,
                                    draggable: false,
                                    position: {lat: elem?.lat, lng: elem?.longitude},
                                    title: elem?.title
                                }}
                                onClick={(ID) => {

                                }}
                            />
                        ))
                    }
                    {
                        temp_pois && temp_pois.map(elem =>
                            <MarkerCustom
                                size={32}
                                name="GPS_TEMP.png"
                                key={elem?._id}
                                data={{
                                    ID: elem?._id,
                                    draggable: false,
                                    position: {lat: elem?.LAT.toString(), lng: elem?.LONG.toString()},
                                    title: elem?.title
                                }}
                                onClick={(ID) => {
                                    //if (props?.onSelectedTempPoi) props?.onSelectedTempPoi(ID);
                                }}
                            />
                        )
                    }
                    <LeafletgeoSearch/>
                    <ClickInteraction/>
                </LayersControl>
            </MapContainer>
            <Popup isOpen={modalOpen} onClose={() => setModalOpen(false)} popupData={popupData}/>
        </div>
    );
};

export default DimensioneMap;

{/*<MapContainer
                key={position}
                center={position}
                style={{height: '100%'}}
                zoom={5}
                scrollWheelZoom={false}
                onViewportChanged={onViewportChanged}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker
                    draggable={true}
                    eventHandlers={eventHandlers}
                    position={position}
                    ref={markerRef}>
                </Marker>
            </MapContainer>*/
}
